import {EnvConfig} from "../../../Shared/Constants/environtmentConstants";

export const getSingleBlogData = async (path: string) => {
    const response = await fetch(EnvConfig().winahost_api_url + `/blog/${path}/showByPath`);
    const data = await response.json();
    return data.data
}
